module.exports = __webpack_public_path__ + "fonts/Raleway-BoldItalic.2c6f0ac3.ttf";